import commonResource from '../../locales/th/common.json';
import { PropertyType } from '../../common/helpers/domain/propertyTypes';

export const getPropertyTypeInputOptions = (): {
  name: string;
  key: string;
}[] => {
  return [
    {
      name: commonResource.propertyTypes.condominium,
      key: PropertyType.Condominium,
    },
    {
      name: commonResource.propertyTypes.house,
      key: PropertyType.House,
    },
    {
      name: commonResource.propertyTypes.townhome,
      key: PropertyType.Townhome,
    },
    {
      name: commonResource.propertyTypes.holidayHomes,
      key: PropertyType.HolidayHomes,
    },
    {
      name: commonResource.propertyTypes.homeOffice,
      key: PropertyType.HomeOffice,
    },
    {
      name: commonResource.propertyTypes.mixedUse,
      key: PropertyType.MixedUse,
    },
    {
      name: commonResource.propertyTypes.commercial,
      key: PropertyType.Commercial,
    },
  ];
};
